import { render, staticRenderFns } from "./TrackForbidden.vue?vue&type=template&id=43ce6756&"
import script from "./TrackForbidden.vue?vue&type=script&lang=js&"
export * from "./TrackForbidden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports